<template>
  <div style="position: relative; width: 100%">
    <el-row>
      <el-col :span="24">
        <card title="Filtrar" subTitle="Por favor seleccione las opciones siguientes:">
          <hr class="mt-1">
          <el-row :gutter="20">
            <el-col :span="10">
              <label>Fecha de Cierre</label>
              <el-date-picker
                v-model="rangeDate"
                clearable
                class="shadow-sm required-year"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="-"
                placeholder="Seleccione..."
                start-placeholder="Fecha Inicial"
                end-placeholder="Fecha Final">
              </el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-button type="info" style="margin-top: 26px" @click="filter">Filtrar...</el-button>
            </el-col>
          </el-row>
        </card>
        <card
          v-if="tableData.length > 0"
        >
          <el-row>
            <el-col :span="24">
              <!-- <highcharts class="chart" :constructor-type="'chart'" :options="chartOptions"></highcharts> -->
              <highcharts class="chart" :constructor-type="'chart'" :options="chartOptions"></highcharts>
            </el-col>
          </el-row>
        </card>
        <card
          v-if="tableData.length > 0"
        >
          <el-row>
            <el-col :span="24">
              <highcharts class="chart" :constructor-type="'chart'" :options="chartOptions2"></highcharts>
            </el-col>
          </el-row>
        </card>
        <card
          v-if="tableData.length > 0"
          title="Tabla de Operaciones"
          subTitle="Operaciones realizadas en el filtro de fecha seleccionado"
        >
          <hr>
          <el-col :span="24" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              placeholder="Por página"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              show-word-limit
              class="mb-3 shadow-sm"
              style="width: 200px"
              placeholder="Buscar registros"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </el-col>
          <el-col :span="24">
            <el-table
              stripe
              :default-sort="{prop: 'ticket', order: 'descending'}"
              style="width: 100%;"
              :data="queriedData"
              border
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
            </el-table>
          </el-col>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { Table, TableColumn, Row, Col, Select, Option, Button } from "element-ui";
import { Pagination as LPagination } from "src/components/index";
import { Axios } from "src/custom_objetcs/Axios.js";
import {Chart} from 'highcharts-vue';
import moment from "moment";
import MixinDatePicker from "src/mixins/DatePicker.js";
import MixinHighChart from "src/mixins/Highchart.js";
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
import DataDashboardTable2 from "./DemoTables/DataDashboard2";

exportingInit(Highcharts)

/* import Highcharts from "highcharts";
import dataModule from "highcharts/modules/data";
import drilldown from "highcharts/modules/drilldown";

drilldown(Highcharts);
dataModule(Highcharts); */

/* let drilldownChart, drilldownEvent, drilldownLevel = 0;
const chartOptions = {
    chart: {
      "type": "column",
      events: {
        drilldown: function(e) {
          if (!e.seriesOptions) {
            console.log(this);
            this.vueRef.updateGraph(true, this, e);
          }
        },
        drillup: function(e) {
          if (!e.seriesOptions.flag) {
            this.vueRef.drilldownLevel = e.seriesOptions._levelNumber;
            this.vueRef.updateGraph(false);
          }
        }
      }
    },
    credits: {
      "enabled": false
    },
    plotOptions: {

      column: {
        stacking: "normal",
        events: {
          click: function(event) {
            return false;
          }
        }
      },
      "series": {
        "borderWidth": 0,
        "dataLabels": {
          "enabled": true,
          "style": {
            "textShadow": false,
            "fontSize": "10px"
          }
        }
      }
    },
    "legend": {
      "enabled": false,
    },
    "yAxis": {
      "stackLabels": {
        "enabled": false,
        "style": {
          "fontWeight": "bold",
          "color": "gray"
        }
      }
    },
    "title": {
      "text": "Stacked Column Drilldown Chart",
      "fontWeight": "bold"
    },
    "xAxis": {
      "title": {},
      "type": "category"
    },
    "yAxis": [{
      "title": {
        "text": "Number of Students"
      },
      "min": 0,
      "allowDecimals": false
    }],
    "series": [{

      "name": "Outstanding",
      "color": "rgb(102, 168, 255)",
      "data": [{
        "name": "English",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "105"
      }, {
        "name": "Social Science",
        "y": 1,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "119",
        "drilldown": true
      }, {
        "name": "Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "126"
      }, {
        "name": "Maths",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "139"
      }, {
        "name": "Hindi",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "146"
      }]
    }, {
      type: 'column',
      "name": "Very Good",
      "color": "rgb(128, 183, 255)",
      "data": [{
        "name": "English",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "105"
      }, {
        "name": "Social Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "119",
        "drilldown": true
      }, {
        "name": "Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "126"
      }, {
        "name": "Maths",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "139"
      }, {
        "name": "Hindi",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "146"
      }]
    }, {
      type: 'column',
      "name": "Satisfactory",
      "color": "rgb(179, 212, 255)",
      "data": [{
        "name": "English",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "105"
      }, {
        "name": "Social Science",
        "y": 1,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "119",
        "drilldown": true
      }, {
        "name": "Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "126"
      }, {
        "name": "Maths",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "139"
      }, {
        "name": "Hindi",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "146"
      }]
    }, {
      type: 'column',
      "name": "Needs Improvement",
      "color": "rgb(204, 226, 255)",
      "data": [{
        "name": "English",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "105"
      }, {
        "name": "Social Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "119",
        "drilldown": true
      }, {
        "name": "Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "126"
      }, {
        "name": "Maths",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "139"
      }, {
        "name": "Hindi",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "146"
      }]
    }, {
      type: 'column',
      "name": "Not Performing",
      "color": "rgb(230, 242, 255)",
      "data": [{
        "name": "English",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "105"
      }, {
        "name": "Social Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "119",
        "drilldown": true
      }, {
        "name": "Science",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "126"
      }, {
        "name": "Maths",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "139"
      }, {
        "name": "Hindi",
        "y": 0,
        "parentCategoryHierarchyId": "0",
        "graphParentId": "146"
      }]
    }]
}; */

export default {
  components: {
    LPagination,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    highcharts: Chart,
    /* drilldownChart,
    drilldownEvent,
    drilldownLevel */
  },

  data() {
    return {
      httpAxios: new Axios(this),
      chartOptions: {},
      chartOptions2: {},
      searchQuery: "",
      tableData: [],
      fuseSearch: null,
      pagination: DataDashboardTable2.table.pagination,
      tableColumns: DataDashboardTable2.table.tableColumns,
    }
  },

  computed: DataDashboardTable2.search,

  mixins: [MixinDatePicker, MixinHighChart],

  methods: {
    filter() {
      this.$emit("cotentLoading", true);
      let data = {
        route: "filterbycitysneighborhood",
        init: moment(this.rangeDate[0]).format("YYYY-MM-DD"),
        end: moment(this.rangeDate[1]).format("YYYY-MM-DD")
      };
      this.httpAxios.postMaster(data).then(success => {
        this.$emit("cotentLoading", false);
        this.tableData = success.data.table;
        this.chartOptions = this.pie(
          success.data.chart1.title,
          success.data.chart1.subtitle,
          success.data.chart1.series,
          success.data.chart1.drilldown.series,
        )
        this.chartOptions2 = this.pie(
          success.data.chart2.title,
          success.data.chart2.subtitle,
          success.data.chart2.series,
          success.data.chart2.drilldown.series,
        )

        this.fuseSearch = new Fuse(this.tableData, {
          useExtendedSearch: true,
          threshold: 0.3,
          keys: this.tableColumns.map(column => {
            return column.prop;
          })
        });
      })
      .catch(error => {
        console.log(error);
        this.$emit("cotentLoading", false);
      });
    },

    /* updateGraph(isDrilldown, chart, e) {
      if (isDrilldown) {
        drilldownLevel++;
        drilldownChart = chart;
        drilldownEvent = e;
        if (drilldownLevel === 1) {
          var drilldowns = {
              'Social Science': {
                name: 'Outstanding',
                color: 'rgb(102, 168, 255)',
                data: [{
                  name: 'Geography',
                  y: 7,
                  drilldown: true
                }, {
                  name: 'History',
                  y: 4
                }, {
                  name: 'Civics',
                  y: 9
                }]
              }
            },
            drilldowns2 = {
              'Social Science': {
                name: 'Very Good',
                color: 'rgb(128, 183, 255)',
                data: [{
                  name: 'Geography',
                  y: 4,
                  drilldown: true
                }, {
                  name: 'History',
                  y: 8
                }, {
                  name: 'Civics',
                  y: 2
                }],
              },
            },
            drilldowns3 = {
              'Social Science': {
                name: 'Satisfactory',
                color: 'rgb(179, 212, 255)',
                data: [{
                  name: 'Geography',
                  y: 4,
                  drilldown: true
                }, {
                  name: 'History',
                  y: 7
                }, {
                  name: 'Civics',
                  y: 1
                }],
              }
            },
            drilldowns4 = {
              'Social Science': {
                name: 'Needs Improvement',
                color: 'rgb(204, 226, 255)',
                data: [{
                  name: 'Geography',
                  y: 2,
                  drilldown: true
                }, {
                  name: 'History',
                  y: 7
                }, {
                  name: 'Civics',
                  y: 2
                }]
              }
            },
            drilldowns5 = {
              'Social Science': {
                name: 'Not Performing',
                color: 'rgb(230, 242, 255)',
                data: [{
                  name: 'Geography',
                  y: 6,
                  drilldown: true
                }, {
                  name: 'History',
                  y: 3
                }, {
                  name: 'Civics',
                  y: 0
                }],
              }
            },
            series = drilldowns[e.point.name],
            series2 = drilldowns2[e.point.name],
            series3 = drilldowns3[e.point.name],
            series4 = drilldowns4[e.point.name],
            series5 = drilldowns5[e.point.name];
          chart.addSingleSeriesAsDrilldown(e.point, series);
          chart.addSingleSeriesAsDrilldown(e.point, series2);
          chart.addSingleSeriesAsDrilldown(e.point, series3);
          chart.addSingleSeriesAsDrilldown(e.point, series4);
          chart.addSingleSeriesAsDrilldown(e.point, series5);
          chart.applyDrilldown();
        } else if (drilldownLevel === 2) {
          var drilldown1 = {
            "Geography": {
              "name": "Yes",
              stacking: 'percent',
              color: 'red',
              "data": [{
                "name": "Q1",
                "y": 1
              }, {
                "name": "Q2",
                "y": 2
              }, {
                "name": "Q3",
                "y": 3
              }, {
                "name": "Q4",
                "y": 4
              }]
            }
          };
          var drilldown2 = {
            "Geography": {
              "name": "No",
              stacking: 'percent',
              color: 'green',
              "data": [{
                "name": "Q1",
                "y": 1
              }, {
                "name": "Q2",
                "y": 2
              }, {
                "name": "Q3",
                "y": 3
              }, {
                "name": "Q4",
                "y": 4
              }]
            }
          };
          var drilldown3 = {
            "exampleDrilldown": {
              type: 'line',
              "name": "Example",
              color: 'black',
              "data": [{
                "name": "Q1",
                "y": 10
              }, {
                "name": "Q2",
                "y": 20
              }, {
                "name": "Q3",
                "y": 30
              }, {
                "name": "Q4",
                "y": 40
              }]
            }
          }
          chart.addSingleSeriesAsDrilldown(e.point, drilldown1[e.point.name]);
          chart.addSingleSeriesAsDrilldown(e.point, drilldown2[e.point.name]);
          chart.addSingleSeriesAsDrilldown(e.point, drilldown3['exampleDrilldown']);
          console.log(e);
          chart.applyDrilldown();
        }
      }
    } */
  },

  mounted() {
    /* console.log(this.$children[0]);
    console.log(this.$children[0].chart);
    this.$children[0].chart.vueRef = this; */
  },
}
</script>
<style>
</style>
